import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()(theme => ({
  icon: {
    marginLeft: theme.spacing(0.5),
    height: '0.75rem !important',
    width: '0.75rem !important',
  },
}));
